
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 13.053c-4.683 0-7.094-5.016-7.195-5.229l-.047-.213.047-.415C.402 6.991 2.646 2.323 7 1.985v-.02l.5-.018c4.683 0 7.095 5.015 7.194 5.229l.048.213-.048.415c-.097.206-2.34 4.873-6.694 5.211v.02l-.5.018zm-.431-1.018H7.5c3.698 0 5.864-3.834 6.233-4.544-.361-.691-2.435-4.347-5.95-4.535l-.283.01c-3.698 0-5.864 3.834-6.233 4.544.356.681 2.376 4.244 5.802 4.525z"}}),_c('path',{attrs:{"d":"M7.5 10.228c-1.504 0-2.728-1.224-2.728-2.728S5.996 4.772 7.5 4.772c1.505 0 2.729 1.224 2.729 2.728S9.005 10.228 7.5 10.228zm0-4.456A1.73 1.73 0 005.772 7.5 1.73 1.73 0 007.5 9.228 1.73 1.73 0 009.229 7.5 1.73 1.73 0 007.5 5.772z"}})])
          )
        }
      }
    